import { Box, Container, Paper, Typography } from '@mui/material';
import { default as Button, default as CustomButton } from '../../../../../core-components/theme/components/Button/Button';
import { EscalationFormData } from '../../../types';
import { useEscalationForm } from '../hooks/useEscalationForm';
import EscalationFormContent from './EscalationFormContent';

const containerStyles = { py: 4 };

const titleBoxStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 4,
};

const paperStyles = {
  borderRadius: 3,
  overflow: 'hidden',
  border: 1,
  borderColor: 'divider',
};

const formContentStyles = { p: 4 };

const buttonContainerStyles = {
  p: 4,
  pt: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
};

interface EscalationFormProps {
  initialData?: EscalationFormData;
  isEditMode: boolean;
}

const EscalationForm = ({ initialData, isEditMode }: EscalationFormProps) => {
  const {
    formData,
    errors,
    pageTitle,
    isLoading,
    onFormChange,
    addEscalationGroup,
    removeEscalationGroup,
    onEscalationGroupUpdate,
    handleSubmit,
    handleCancel,
  } = useEscalationForm({ initialData, isEditMode });

  const submitText = isLoading ? 'Saving...' : isEditMode ? 'Update' : 'Create';

  return (
    <Container maxWidth="lg" sx={containerStyles}>
      <Box sx={titleBoxStyles}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          {pageTitle}
        </Typography>
      </Box>

      <Paper elevation={0} sx={paperStyles}>
        <>
          <Box sx={formContentStyles}>
            <EscalationFormContent
              formData={formData}
              errors={errors}
              onFormChange={onFormChange}
              onAddEscalationGroup={addEscalationGroup}
              onRemoveEscalationGroup={removeEscalationGroup}
              onEscalationGroupUpdate={onEscalationGroupUpdate}
            />
          </Box>

          <Box sx={buttonContainerStyles}>
            <Button
              variant="outlined"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <CustomButton
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {submitText}
            </CustomButton>
          </Box>
        </>
      </Paper>
    </Container>
  );
};

export default EscalationForm;